import { Text } from "@react-pdf/renderer";

export function PageFooter() {
  return (
    <Text
      style={{
        position: "absolute",
        fontSize: 10,
        bottom: 10,
        left: 0,
        right: 0,
        textAlign: "center",
      }}
      render={({ pageNumber, totalPages }) =>
        `Página ${pageNumber} de ${totalPages}`
      }
      fixed
    />
  );
}